import { sanitizeHtml } from "src/utils";

/** Takes in html and sanitises before setting it as the content of the div */
export function SanitiseHTML({ html, ...props }: any) {
  return <div {...props} dangerouslySetInnerHTML={{ __html: sanitizeHtml(html) }} />;
}
